// Contextual WhatsApp links — each page passes its context so the message is pre-loaded.
export const CV_WA_NUMBER = "13053180109";

const MESSAGES = {
  home: "Hola Carlos, entré a clubviajemos.com y me interesa el Travel Empire. ¿Me cuentas cómo arrancar?",
  "sala-ventas": "Hola Carlos, vi el simulador de Sala de Ventas y proyecté mis ingresos. Quiero saber cómo empezar como broker.",
  "club-vacacional": "Hola Carlos, vi el simulador del Club Vacacional y me interesa operar ese modelo. ¿Cómo arranco?",
  certificados: "Hola Carlos, vi el simulador de Certificados de viaje y quiero conocer cómo operar el negocio.",
  manual27: "Hola Carlos, tengo una duda antes de comprar el Manual de $27. ¿Me ayudas?",
  "orlando-lead": "Hola Carlos, dejé mis datos para el regalo de 3 días en Orlando. ¿Cómo activo mi reserva?",
  comunidad: "Hola Carlos, me interesa publicar mi paquete en la comunidad de Club Viajemos.",
  curso: "Hola Carlos, ya estoy en el curso de videos y tengo una consulta.",
  protocolo: "Hola Carlos, vi el Protocolo Maestro 2026 y quiero confirmar mi cohorte.",
  default: "Hola Carlos, te contacto desde clubviajemos.com.",
};

export const waLink = (context = "default") => {
  const msg = encodeURIComponent(MESSAGES[context] || MESSAGES.default);
  return `https://wa.me/${CV_WA_NUMBER}?text=${msg}`;
};
